import Icon from 'veui/components/Icon'
import { IconCheckSquare } from 'dls-icons-vue'

Icon.register('check-square', IconCheckSquare)
